module.exports = __webpack_public_path__ + "static/media/layout3-img.a0a542fc.svg";